import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'src.pages.ConsentPopUp.title',
    defaultMessage: 'Things to remember before starting your claim',
  },
  getFamiliarSubtitle: {
    id: 'src.pages.ConsentPopUp.getFamiliarSubtitle',
    defaultMessage: 'Get familiar with your coverage before submitting a claim:',
  },
  getFamiliar1: {
    id: 'src.pages.ConsentPopUp.getFamiliar1',
    defaultMessage: 'To find your policy, click "My Policies" on the dashboard then the policy you want to view',
  },
  getFamiliar2: {
    id: 'src.pages.ConsentPopUp.getFamiliar2',
    defaultMessage: 'See if you have coverage for the specific loss or event',
  },
  getFamiliar3: {
    id: 'src.pages.ConsentPopUp.getFamiliar3',
    defaultMessage: 'Check if there are any exclusions that aren’t covered',
  },
  getFamiliar4: {
    id: 'src.pages.ConsentPopUp.getFamiliar4',
    defaultMessage: 'Remember to follow any specific claim procedures',
  },
  getFamiliar5: {
    id: 'src.pages.ConsentPopUp.getFamiliar5',
    defaultMessage: 'Make sure you know the time frame to submit your claim',
  },
  otherTipsSubtitle: {
    id: 'src.pages.ConsentPopUp.otherTipsSubtitle',
    defaultMessage: 'Other tips for submitting a claim:',
  },
  otherTips1: {
    id: 'src.pages.ConsentPopUp.otherTips1',
    defaultMessage: 'Take photos of any damage',
  },
  otherTips2: {
    id: 'src.pages.ConsentPopUp.otherTips2',
    defaultMessage: 'Have details or notes from the incident handy',
  },
  otherTips3: {
    id: 'src.pages.ConsentPopUp.otherTips3',
    defaultMessage: 'Gather helpful documentation such as bills or receipts (for ambulance or fire truck costs, medical expenses, cleaning services etc.)',
  },
  otherTips4: {
    id: 'src.pages.ConsentPopUp.otherTips4',
    defaultMessage: 'Make sure you have contact info for everyone involved',
  },
  checkbox: {
    id: 'src.pages.ConsentPopUp.checkbox',
    defaultMessage: 'I confirm that, to the best of my knowledge, the information being submitted is true and accurate. I understand that making a false or misleading statement may result in my claim or benefits being denied and may constitute an offence under provincial insurance legislation and the Criminal Code of Canada.',
  },
  checkbox2: {
    id: 'src.pages.ConsentPopUp.checkbox2',
    defaultMessage: 'I allow Sonnet Insurance Company to share my information with third parties as needed to process my claim and in accordance with the Privacy Policy.',
  },
  error: {
    id: 'src.pages.ConsentPopUp.error',
    defaultMessage: 'Oops! Looks like you forgot to fill this in.',
  },
  button: {
    id: 'src.pages.ConsentPopUp.button',
    defaultMessage: 'Okay',
  },
});
